export default "__VITE_ASSET__2kUL350r__"